import {
  deleteLibraryItem,
  listLibraryItems,
  uploadLibraryFile,
} from './sharepoint';

const LIST = 'salesResources';

/**
 * Sales Resources live in a SharePoint *document library* rather than a
 * generic list — Directors upload actual files (one-pagers, decks, case
 * studies) and the portal surfaces them as tiles with a Download action.
 * All storage happens inside SharePoint, so files inherit the tenant's
 * permissions, versioning, and retention policies without us re-rolling
 * an upload pipeline.
 */

/**
 * List every resource in the library, newest first (by PostedAt, which
 * we set on upload). Each row has:
 *   - id, driveItemId, fileName, sizeBytes, downloadUrl, webUrl
 *   - Title, Description, Category, PostedBy, PostedAt
 */
export async function listSalesResources(opts) {
  const rows = await listLibraryItems(LIST, opts);
  // Sort newest-upload first. A SharePoint orderby on fields/PostedAt is
  // available but we also want to cover rows uploaded before PostedAt
  // existed — sort client-side so either case reads naturally.
  return rows.sort((a, b) => {
    const ta = Date.parse(a.PostedAt || a.Modified || a.Created || '') || 0;
    const tb = Date.parse(b.PostedAt || b.Modified || b.Created || '') || 0;
    return tb - ta;
  });
}

/**
 * Upload a resource. `file` is a browser File; the remaining fields are
 * stored as list-item columns alongside the uploaded file.
 *
 * Title defaults to the file's base name so Directors can skip the field
 * when they're happy with what SharePoint derives from the filename.
 */
export async function createSalesResource({
  file,
  Title,
  Description = '',
  Category = '',
  PostedBy = '',
  PostedAt,
}) {
  if (!file) throw new Error('createSalesResource: file is required.');
  const fallbackTitle = (file.name || '').replace(/\.[^.]+$/, '');
  const fields = {
    Title: (Title || fallbackTitle || 'Untitled').trim(),
    Description,
    Category,
    PostedBy,
    PostedAt: PostedAt || new Date().toISOString(),
  };
  return uploadLibraryFile(LIST, file, fields);
}

export const deleteSalesResource = (id) => deleteLibraryItem(LIST, id);
